import type { ComponentProps } from "react";

import { twMerge } from "tailwind-merge";

export const Input = ({ className, ...props }: ComponentProps<"input">) => {
  return (
    <input
      placeholder="COMING SOON"
      // placeholder="Your address"
      className={twMerge(
        "rounded-lg border border-white/20 bg-oil p-[15px] font-minecraft text-sm outline-none",
        className
      )}
      {...props}
    />
  );
};
